import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { GridStackComponent } from "./grid-stack/grid-stack.component";
import { UiModule } from "../ui/ui.module";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { RouterModule } from "@angular/router";
import { InputComponent } from "../inputs/input/input.component";
import { SelectComponent } from "../inputs/select/select.component";
import { AngularSvgIconModule } from "angular-svg-icon";
import { AreYouSureDialogComponent } from "./dialogs/are-you-sure-dialog/are-you-sure-dialog.component";
import { FilterTableDialogComponent } from "./dialogs/filter-table-dialog/filter-table-dialog.component";
import { OptionSnackGroupComponent } from "./option-snack/option-snack-group/option-snack-group.component";
import { OptionSnackComponent } from "./option-snack/option-snack/option-snack.component";
import { TextAreaComponent } from "../inputs/text-area/text-area.component";
import { DatepickerComponent } from "../inputs/datepicker/datepicker.component";
import { SignalPreviewDialogComponent } from "./dialogs/signal-preview-dialog/signal-preview-dialog.component";
import { UnsanitzedHtml } from "./pipes/unsanitized-html.pipe";
import { DateTimePipe } from "./pipes/datetime.pipe";
import { AudienceListComponent } from "../broadcasts/audiences/audience-list/audience-list.component";
import { BroadcastComponent } from "../broadcasts/broadcast/broadcast.component";
import { AudienceContainerComponent } from "../broadcasts/audiences/audience-container/audience-container.component";
import { NgxFileDropModule } from "ngx-file-drop";
import { NgxFilesizeModule } from "ngx-filesize";
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { GooglePlacesUtil } from "./google-places-util/google-places-util";
import { BeaconRegionFilterPipe } from "../pipes/beaconRegionFilter.pipe";
import { BeaconFilterPipe } from "../pipes/beaconFilter.pipe";
import { GoogleMapsModule } from "@angular/google-maps";
import { QuestionAnswerTextComponent } from "./dialogs/question-answer-text/question-answer-text.component";
import { SToHHMMSSPipe } from "./pipes/sToHHMMSS.pipe";
import { FacilitySelectDialogComponent } from './dialogs/facility-select-dialog/facility-select-dialog.component';
import { GeofenceSelectDialogComponent } from './dialogs/geofence-select-dialog/geofence-select-dialog.component';
import { AssistantChatComponent } from "./chat/chat.component";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { ProfileCatalogComponent } from './profile-catalog/profile-catalog.component';
import { EditorModule } from '@tinymce/tinymce-angular';
import { VariableNameValidatorDirective } from './directives/variable-name-validator.directive';
import { CustomerSearchDialogComponent } from './dialogs/customer-search-dialog/customer-search-dialog.component';
import { SaveSearchDialogComponent } from './dialogs/save-search-dialog/save-search-dialog.component';
import { QueryBuilderComponent } from './query-builder/query-builder.component';
import { AccountPrerequisiteDialogComponent } from "./dialogs/account-prerequisite-dialog/account-prerequisite-dialog.component";
import { TripistEmbedComponent } from './tripist-embed/tripist-embed.component';

@NgModule({
  declarations: [
    GridStackComponent,
    InputComponent,
    SelectComponent,
    TextAreaComponent,
    DatepickerComponent,
    AreYouSureDialogComponent,
    FilterTableDialogComponent,
    OptionSnackGroupComponent,
    OptionSnackComponent,
    SignalPreviewDialogComponent,
    UnsanitzedHtml,
    DateTimePipe,
    AudienceListComponent,
    BroadcastComponent,
    AudienceContainerComponent,
    BeaconFilterPipe,
    BeaconRegionFilterPipe,
    QuestionAnswerTextComponent,
    SToHHMMSSPipe,
    FacilitySelectDialogComponent,
    GeofenceSelectDialogComponent,
    AssistantChatComponent,
    ProfileCatalogComponent,
    VariableNameValidatorDirective,
    CustomerSearchDialogComponent,
    SaveSearchDialogComponent,
    QueryBuilderComponent,
    AccountPrerequisiteDialogComponent,
    TripistEmbedComponent,
  ],
  imports: [CommonModule, UiModule, RouterModule, AngularSvgIconModule, MatProgressSpinnerModule, EditorModule],
  exports: [
    NgxPermissionsModule,
    GridStackComponent,
    InfiniteScrollModule,
    InputComponent,
    SelectComponent,
    TextAreaComponent,
    DatepickerComponent,
    AngularSvgIconModule,
    AreYouSureDialogComponent,
    FilterTableDialogComponent,
    OptionSnackGroupComponent,
    OptionSnackComponent,
    UnsanitzedHtml,
    DateTimePipe,
    AudienceListComponent,
    BroadcastComponent,
    AudienceContainerComponent,
    NgxFileDropModule,
    NgxFilesizeModule,
    GoogleMapsModule,
    GooglePlaceModule,
    GooglePlacesUtil,
    BeaconFilterPipe,
    BeaconRegionFilterPipe,
    QuestionAnswerTextComponent,
    SToHHMMSSPipe,
    AssistantChatComponent,
    MatProgressSpinnerModule,
    EditorModule,
    VariableNameValidatorDirective,
    CustomerSearchDialogComponent,
    SaveSearchDialogComponent,
    QueryBuilderComponent,
    AccountPrerequisiteDialogComponent,
    TripistEmbedComponent
  ],
})
export class SharedModule {}
